import {FirebaseTopicModel} from "../../firebase-topic-model";
import {IIGCLiveProgressUpdate, IIGCLiveProgressUpdateData} from "./live-progress-update-topic.model.interface";

export class IGCLiveProgressUpdateModel extends FirebaseTopicModel<IIGCLiveProgressUpdate, IIGCLiveProgressUpdateData> {
    getTopicName(): string {
        // TODO: Replace 86518 with dynamic campaign ID when available
        return `CampaignsNotification/${this.services.user.cid}_86518`;
    }
    getTopicLabel(): string {
        return "CampaignsNotificationUpdate";
    }
    protected _mapRawMessageToPublishMessage(rawMessage: IIGCLiveProgressUpdate): IIGCLiveProgressUpdateData {
        const data = {
            CampaignId: rawMessage.CampaignId,
            CampaignExpirationDate: rawMessage.CampaignExpirationDate,
            RuleId: rawMessage.RuleId,
            RuleCompletedActions: rawMessage.RuleCompletedActions,
            RuleRequiredActions: rawMessage.RuleRequiredActions,
            CampaignRuleCompleted: rawMessage.CampaignRuleCompleted,
            CampaignRuleRequired: rawMessage.CampaignRuleRequired,
        }
        return data;
    }
}